(function() {
    function getSectionsToRender() {
        return [
          {
            selector: 'js-main-product',
            sectionId: document.querySelector('[js-main-product]')?.dataset.section
          },
          {
            selector: 'js-ingredients-section',
            sectionId: document.querySelector('[js-ingredients-section]')?.dataset.sectionId
          },
          {
            selector: 'js-ingredients-popup',
            sectionId: document.querySelector('[js-ingredients-popup]')?.dataset.sectionId
          },
          {
            selector: 'js-video-banner',
            sectionId: document.querySelector('[js-video-banner]')?.dataset.sectionId
          },
          {
            selector: 'js-comparison-table',
            sectionId: document.querySelector('[js-comparison-table]')?.dataset.sectionId
          },
          {
            selector: 'js-reviews-section',
            sectionId: document.querySelector('[js-reviews-section]')?.dataset.sectionId
          },
          {
            selector: 'js-related-products',
            sectionId: document.querySelector('[js-related-products]')?.dataset.sectionId
          }
        ];
    };    

    function renderSections(handle) {
        getSectionsToRender().forEach(section => {
            fetch(`/products/${handle}?section_id=${section.sectionId}`)
            .then( response => response.text())
            .then(html => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                
                const elementToReplace = document.querySelector(`[${section.selector}]`);
               
                if(elementToReplace) {
                    elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`) ? doc.querySelector(`[${section.selector}]`).innerHTML : '';
                };

                if(section.selector === 'js-video-banner') {
                    document.dispatchEvent(new CustomEvent("sounds-trigger:init"))
                }else if(section.selector === 'js-comparison-table') {
                    document.dispatchEvent(new CustomEvent("chart-slider:init"))
                }else if(section.selector === 'js-reviews-section') {
                    okeWidgetApi?.initAllWidgets();
                }else if(section.selector === 'js-related-products') {
                    document.body.classList.remove("disabled");
                    document.dispatchEvent(new CustomEvent("recommendations-slider:init"));
                }else if(section.selector === 'js-main-product') {
                    document.dispatchEvent(new CustomEvent("skio-subscription-toggle:init"));

                    if(document.querySelector('.variant_title_desktop_new')) {
                        document.dispatchEvent(new CustomEvent("custom-option:init"))
                    }
                    if($(".accordion .question").length) {
                       document.dispatchEvent(new CustomEvent("accordion:init"));
                    }
                }
            })
            .catch(function(error) {
                console.log(error);
            });
        });
    };

    document.addEventListener("render-section:init", function({ detail : { handle }}) {
        renderSections(handle);
    });

    class productSwatches extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                swatchItem: "[js-swatch-item]",
                swatchHandle: "[js-swatch-handle]"
            };
    
            this.classes = {
                activeClass: 'active'
            }
    
            this.swatchItems = this.querySelectorAll(this.selectors.swatchItem);
            this.swatchHandle = this.querySelector(this.selectors.swatchHandle);
            
            this.init();
        };
    
        init() {
            this.swatchItems.forEach( swatchItem => {
                swatchItem.addEventListener('click', ({currentTarget}) => {
                    this.toggleProduct(currentTarget);
                })
            });
        };
        
    
        toggleProduct(targetProduct) {
            const productHandle = targetProduct.dataset.productHandle;
            const swatchHandle = targetProduct.dataset.swatchHandle;

            // Temporary bypass. Subscription widget wasn't loading if first visit to PDP didn't include it.
            var newurl = `${window.location.protocol}//${window.location.host}/products/${productHandle}`;
            window.location = newurl;

            // this.updateState(targetProduct);
            // renderSections(productHandle);
            // setTimeout(()=>{ this.updateHistoryState(productHandle);},200)

        };
    
        updateState(targetEl) {
            document.body.classList.add("disabled");
            this.swatchItems.forEach( item => item.classList.remove(this.classes.activeClass));
            targetEl.classList.add(this.classes.activeClass);
        };
    
        updateHistoryState(handle) {
            var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
            window.history.pushState({path: newurl}, '', newurl);
        };
    }
      
    customElements.define('product-swatches', productSwatches);
})()